import { FIELD_TYPE } from "types/enums";
import React from "react";
import { formatToCurrencyType } from "helper/common";

const { INPUT, SELECT, DATE, CODE, COMBO_BOX } = FIELD_TYPE;

const dataField: any[] = [
  {
    type: DATE,
    label: "Thời gian từ",
    name: "start",
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 12,
      xs: 24,
    },
    labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
    wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
  },
  {
    type: DATE,
    label: "Thời gian tới",
    name: "end",
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 12,
      xs: 24,
    },
    labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
    wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
  },
];

const columnsTable: any = [
  {
    title: "Ngày",
    dataIndex: "ngay",
    key: "ngay",
    width: 100,
    align: "center",
  },
  {
    title: "Tổng số khám",
    dataIndex: "tongSoKham",
    key: "tongSoKham",
    width: 100,
    align: "right",
  },
  {
    title: "Số BN thanh toán tiền khám",
    children: [
      {
        title: "Dưới 6 tuổi",
        dataIndex: "soBNTTDuoi6",
        key: "soBNTTDuoi6",
        width: 100,
        align: "right",
      },
      {
        title: "Trên 60 tuổi",
        dataIndex: "soBNTTTren60",
        key: "soBNTTTren60",
        width: 100,
        align: "right",
      },
      {
        title: "Khác",
        dataIndex: "soBNTTKhac",
        key: "soBNTTKhac",
        width: 100,
        align: "right",
      },
    ],
  },
  {
    title: "Khám miễn phí",
    key: "soPhieuKhamHon60ThanhToan",
    children: [
      {
        title: "Dưới 6 tuổi",
        dataIndex: "khamMPDuoi6",
        key: "khamMPDuoi6",
        width: 100,
        align: "right",
      },
      {
        title: "Trên 60 tuổi",
        dataIndex: "khamMPTren60",
        key: "khamMPTren60",
        width: 100,
        align: "right",
      },
      {
        title: "Khác",
        dataIndex: "khamMPKhac",
        key: "khamMPKhac",
        width: 100,
        align: "right",
      },
    ],
  },
  {
    title: "Số thủ thuật",
    dataIndex: "soThuThuat",
    key: "soThuThuat",
    align: "right",
  },
  {
    title: "Số chỉ định phẫu thuật",
    align: "right",
    children: [
      
      {
        title: "Tổng",
        dataIndex: "tongChiDinhPT",
        key: "tongChiDinhPT",
        width: 100,
        align: "right",
      },
      {
        title: "Nam",
        dataIndex: "namChiDinhPT",
        key: "namChiDinhPT",
        width: 50,
        align: "right",
      },
      {
        title: "Nữ",
        dataIndex: "nuChiDinhPT",
        key: "nuChiDinhPT",
        width: 50,
        align: "right",
      },
    ],
  },
  {
    title: "Đoàn",
    dataIndex: "doan",
    key: "doan",
    align: "right",
  },
  {
    title: "Khám mới",
    dataIndex: "khamMoi",
    key: "khamMoi",
    align: "right",
    children: [
      {
        title: "Tổng",
        dataIndex: "khamMoiTong",
        key: "khamMoiTong",
        width: 100,
        align: "right",
      },
      {
        title: "Khám miễn phí",
        dataIndex: "khamMoiMP",
        key: "khamMoiMP",
        width: 100,
        align: "right",
      },
      {
        title: "Đoàn",
        dataIndex: "khamMoiDoan",
        key: "khamMoiDoan",
        width: 100,
        align: "right",
      },
    ],
  },
  {
    title: "Khám lại",
    key: "soPhieuKhamTrong60",
    children: [
      {
        title: "Tổng",
        dataIndex: "khamLaiTong",
        key: "khamLaiTong",
        width: 100,
        align: "right",
      },
      {
        title: "Khám miễn phí",
        dataIndex: "khamLaiMP",
        key: "khamLaiMP",
        width: 100,
        align: "right",
      },
      {
        title: "Đoàn",
        dataIndex: "khamLaiDoan",
        key: "khamLaiDoan",
        width: 100,
        align: "right",
      },
    ],
  },
  {
    title: "Giới tính",
    dataIndex: "BenhNhanTTOPD",
    key: "benhNhanTTOPD",
    align: "right",
    children: [
      {
        title: "Nam",
        dataIndex: "nam",
        key: "nam",
        width: 100,
        align: "right",
      },
      {
        title: "Nữ",
        dataIndex: "nu",
        key: "nu",
        width: 100,
        align: "right",
      },
      {
        title: "Nam(Đoàn)",
        dataIndex: "namDoan",
        key: "namDoan",
        width: 100,
        align: "right",
      },
      {
        title: "Nữ(Đoàn)",
        dataIndex: "nuDoan",
        key: "nuDoan",
        width: 100,
        align: "right",
      },
    ],
  },
  {
    title: "Tổng khám miễn phí",
    dataIndex: "tongKhamMP",
    key: "tongPhieuKhamDoan",
    align: "right",
  },
];

export { dataField, columnsTable };
